<template>
    <div class="d-flex justify-content-end">
        <button class="btn btn-primary" @click="closeWindow()">Close</button>
    </div>
</template>

<script>
    export default {
        name: 'housecall-pro-authorization-complete',

        data() {
            return {}
        },

        methods: {
            closeWindow() {
                window.close();
            }
        }
    }
</script>
